import { useQuery } from '@tanstack/react-query';

const IOS_INITIATED_CHANGE_USER_QUERY_KEY = ['iosInitiatedChangeUser'] as const;

// Kept as a query (rather than a direct read) so refetchOnWindowFocus re-reads the flag when the
// native app brings the webview back to foreground after signalling a user change — a plain read
// has nothing to re-trigger it. queryFn is async to avoid the synchronous-resolve re-render loop
// that a sync queryFn causes on react-query 5.101 (issue #1027).
const readIosInitiatedChangeUser = async (): Promise<string | null> =>
  sessionStorage.getItem('ios_initiated_change_user');

export const useIosInitiatedChangeUser = () =>
  useQuery({
    queryFn: readIosInitiatedChangeUser,
    queryKey: IOS_INITIATED_CHANGE_USER_QUERY_KEY,
  });
